import { render, staticRenderFns } from "./KeyboardShortcutKey.vue?vue&type=template&id=3e16b78e&scoped=true&"
import script from "./KeyboardShortcutKey.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutKey.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardShortcutKey.vue?vue&type=style&index=0&id=3e16b78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16b78e",
  null
  
)

export default component.exports